var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"el-login-footer"},[_c('span',[_vm._v("Copyright © 2023 蓝鲸众联 All Rights Reserved.")]),_c('br'),_c('span',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("浙ICP备2022008018号-1")])])])
}]

export { render, staticRenderFns }